import { render } from "./AddFirstTimer.vue?vue&type=template&id=674c4fcf&scoped=true"
import script from "./AddFirstTimer.vue?vue&type=script&lang=js"
export * from "./AddFirstTimer.vue?vue&type=script&lang=js"

import "./AddFirstTimer.vue?vue&type=style&index=0&id=674c4fcf&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674c4fcf"]])

export default __exports__